"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const common_1 = require("../@inax/common");
const app_component_1 = require("./components/app.component");
//services
const logger_1 = require("../@inax/logger");
const frontend_1 = require("../@inax/frontend");
const plc_1 = require("../@inax/plc");
const sql_1 = require("../@inax/sql");
const excel_1 = require("../@inax/excel");
const translate_1 = require("../@inax/translate");
const script_1 = require("../@inax/script");
const app_routes_1 = require("./app.routes");
const translations_1 = require("./resources/translations");
const ng2_toastr_1 = require("ng2-toastr/ng2-toastr");
const sqlviewer_component_1 = require("./components/sqlviewer/sqlviewer.component");
const home_component_1 = require("./components/home/home.component");
const serviceLogin_component_1 = require("./components/serviceLogin/serviceLogin.component");
const plcviewer_component_1 = require("./components/plcviewer/plcviewer.component");
const scriptviewer_component_1 = require("./components/scriptviewer/scriptviewer.component");
const configurationviewer_component_1 = require("./components/configurationviewer/configurationviewer.component");
const testpage_component_1 = require("./components/testpage/testpage.component");
const commonUi_module_1 = require("./../@inax/commonUi/src/commonUi.module");
const alarmUi_module_1 = require("./../@inax/alarmUi/src/alarmUi.module");
const translate_module_1 = require("./../@inax/translate/src/translate.module");
const motionUi_module_1 = require("../@inax/motionUi/src/motionUi.module");
const plcUi_module_1 = require("../@inax/plcUi/src/plcUi.module");
const userAuthentication_module_1 = require("../@inax/userAuthentication/src/userAuthentication.module");
const inaxConfigUi_module_1 = require("../@inax/inaxConfigUi/src/inaxConfigUi.module");
const buttonMenu_module_1 = require("../@inax/buttonMenuUi/src/buttonMenu.module");
const router_1 = require("@angular/router");
const RoutingDisabler_service_1 = require("../@inax/common/src/routing/RoutingDisablerService/RoutingDisabler.service");
const provide_1 = require("../@inax/userAuthentication/src/provide");
const menu_1 = require("./resources/menu");
const provider_1 = require("../@inax/plc/src/provider");
const provider_2 = require("../@inax/script/src/provider");
const provider_3 = require("../@inax/alarm/src/provider");
const provider_4 = require("../@inax/common/src/provider");
const provider_5 = require("../@inax/menu/src/provider");
let AppModule = class AppModule {
};
AppModule = __decorate([
    core_1.NgModule({
        imports: [
            //Modules
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            router_1.RouterModule,
            app_routes_1.APP_ROUTES,
            translate_module_1.TranslateModule,
            alarmUi_module_1.AlarmUiModule,
            motionUi_module_1.MotionUiModule,
            commonUi_module_1.CommonUiModule,
            plcUi_module_1.PlcUiModule,
            userAuthentication_module_1.UserAuthenticationModule,
            buttonMenu_module_1.ButtonMenuModule,
            inaxConfigUi_module_1.InaxConfigUiModule
        ],
        declarations: [
            //Components
            app_component_1.AppComponent,
            home_component_1.HomeComponent,
            serviceLogin_component_1.ServiceLoginComponent,
            plcviewer_component_1.PlcViewerComponent,
            scriptviewer_component_1.ScriptViewerComponent,
            sqlviewer_component_1.SqlViewerComponent,
            configurationviewer_component_1.ConfigurationViewerComponent,
            testpage_component_1.TestPageComponent,
            //Pipes
            sqlviewer_component_1.KeysPipe
        ],
        providers: [
            //Services
            //{ provide: SignalrWindow, useValue: window },
            //{ provide: IHUBSERVICE_TOKEN, useClass: InaxPlcService, multi: true },
            //{ provide: IHUBSERVICE_TOKEN, useClass: InaxScriptService, multi: true },
            //{ provide: IHUBSERVICE_TOKEN, useClass: InaxAlarmService, multi: true },
            //{ provide: IUSERAUTHENTICATIONSERVICE_TOKEN, useClass: UserAuthenticationService, multi: false },
            //{ provide: IUSERAUTHSTATESERVICE_TOKEN, useClass: UserAuthStateService, multi: false },
            //{ provide: IMENUPROVIDERSERVICE_TOKEN, useClass: DefaultMenuProvider, multi: false },
            //{ provide: ALARM_CONFIG_TOKEN, useValue: DEFAULT_ALARM_SETTINGS, multi: false },
            //{ provide: IINAXCONFIGSERVICE_TOKEN, useClass: InaxConfiguration, multi: false },
            provider_4.SIGNALR_PROVIDER_ENTRY,
            provider_4.INAX_CONFIG_PROVIDER_ENTRY,
            provider_1.PLC_HUBSERVICEPROVIDER_ENTRY,
            provider_2.SCRIPT_HUBSERVICEPROVIDER_ENTRY,
            provider_3.ALARM_HUBSERVICEPROVIDER_ENTRY,
            provider_3.ALARM_CONFIG_PROVIDER_ENTRY,
            provider_4.EXPANDABLE_PANEL_COLLECTION_ENTRY,
            provide_1.DEFAULT_USER_AUTH_SERVICE_PROVIDER_ENTRY,
            provide_1.DEFAULT_USER_AUTH_STATE_SERVICE_PROVIDER_ENTRY,
            provider_5.DEFAULT_MENU_PROVIDER_ENTRY,
            /** declared in app */
            menu_1.APP_MENU,
            translations_1.TRANSLATIONS,
            /**Services */
            common_1.InaxConfiguration,
            common_1.InaxSignalR,
            frontend_1.InaxFrontendService,
            logger_1.InaxLoggerService,
            plc_1.InaxPlcService,
            sql_1.InaxSqlService,
            common_1.ProfileService,
            ng2_toastr_1.ToastsManager,
            translate_1.InaxTranslateService,
            excel_1.InaxExcelService,
            script_1.InaxScriptService,
            RoutingDisabler_service_1.RoutingDisablerService
        ],
        bootstrap: [app_component_1.AppComponent]
    })
], AppModule);
exports.AppModule = AppModule;
